import React, { Component } from "react";
//import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';


import { Button, Modal, ModalBody } from "reactstrap";


import ApiBuy from "../../utils/api.buy";

/*import ApiProfile from "../../utils/api.profile";*/

import Loading from "../../components/Loading";
import ShowValue from "../../components/ShowValue";
import AuthService from "../../utils/auth.service";

let location;
let firebase;
let FB;

class BuyModal extends Component {
  authService = AuthService;
  constructor(props) {
    super(props);

    let profile = localStorage.getItem("userData");
    let company_code = localStorage.getItem("company_code");

    if (profile) {
      profile = JSON.parse(profile);
    }

    this.setState({ loading: true });

    this.state = {
      donation: profile ? profile.donation : 0,
      transaction: this.props.transaction,

      st_company_code: company_code,

      loading: false,
      code: "",
      //ngos: [],
      profile: profile,
      //ngo: this.props.transaction.ngo,
      disableButton: false
    };

    /*console.log('BuyModal');
    console.log(profile); */

    /*firebase.auth().onAuthStateChanged(user => {
      if(user) {
 
        new ApiProfile().getProfile().then(response => {
            this.setState(...this.state, { profile: response.data });
        })
      }
    });*/

    document.addEventListener("profileLoaded", data => {
      if (data.detail) {
        let profile = data.detail.profile;
        this.setState(...this.state, { profile: profile });
      }
    });

    document.addEventListener("profileSave", data => {
      if (data.detail) {
        let profile = data.detail.profile;
        this.setState(...this.state, { profile: profile });
        this.setState(...this.state, {
          donation: this.state.profile ? this.state.profile.donation : 20
        });
      }
    });

    ///TOD: Verificar isto... Estranho tem que ser data.detail que esta comentado...
    document.addEventListener("profileLogout", data => {
      if (data.detail) {
        let profile = data.detail.profile; /* localStorage.getItem("userData"); */
        if (profile) {
          profile = JSON.parse(profile);
        }
        this.setState(...this.state, { profile: profile });
      }
    });


    this._bindToContext("shareFB");
    this._bindToContext("checkNextAction");
    this._bindToContext("handleInputChange");
    this._bindToContext("responseGoogle");
  }

  _bindToContext(f) {
    if (this[f] instanceof Function) {
      this[f] = this[f].bind(this);
    }
  }

  responseGoogle(googleUser) {
    let provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope("https://www.googleapis.com/auth/plus.login");
    firebase.auth().languageCode = "pt";

    firebase.auth().signInWithPopup(provider).then(
      result => {
        this.props.changeAssetLine(this.state.transaction.asset_line);
        this.props.buyAsset();
        this.setState(...this.state, { profile: {} });
      },
      err => { }
    );
  }

  componentWillReceiveProps(props) {
    if (
      this.state.transaction.status !== "approved" ||
      props.transaction.asset_line !== this.state.transaction.asset_line ||
      props.transaction.error
    ) {
      this.setState(...this.state, {
        transaction: props.transaction,
        //ngo: props.transaction.ngo
      });
    }

    this.setState(...this.state, {
      donation: this.state.profile ? this.state.profile.donation : 0
    });
  }

  checkNextAction() {
    if (this.state.profile && this.state.profile.tfa_active && this.state.transaction.status !== "tfa") {
      this._changeToTfaTransaction();
    } else if (this.state.transaction.key) {
      this._confirmUserBuy();
    }
  }

  _changeToTfaTransaction() {
    this.setState(...this.state, {
      transaction: {
        ...this.state.transaction,
        status: "tfa"
      }
    });
  }

  _confirmUserBuy() {
    this.setState(...this.state, { loading: true, disableButton: true });
    if (!this.state.disableButton) {
      new ApiBuy().confirm(this.state.st_company_code, {
        transaction_key: this.state.transaction.key,
        donation: '', //donation: this.state.donation,
        ngo: '', //ngo: this.state.ngo,
        loading: false,
        code: this.state.code,
        company_code: this.state.st_company_code
      }).then(response => {
        if (response.data) {
          if (response.data.status === 401) {
            this.setState(...this.state, {
              loading: false,
              transaction: {
                ...this.state.transaction,
                message: response.data.message,
                status: response.data.status,
                error: true
              },
              disableButton: false
            });

            this.props.changeAssetLine(this.state.transaction.asset_line);
          } else {
            this.setState(...this.state, {
              transaction: response.data,
              loading: false
            });
            this.authService.refresh();
            if (response.data.status !== "refused") {
              this.props.changeAssetLine(this.state.transaction.asset_line);
            }
          }
        }
      }).catch(error => {
        console.log(`error: ${error}`);
      });
    }
  }

  totalSum() {
    let total = 0;
    if (this.state.transaction.split) {
      this.state.transaction.split.forEach(trans => {
        total += trans.value_pair.value;
      });
    }
    return total;
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState(...this.state, { [name]: value });
  }

  tableItems() {

    if (this.state.transaction.split) {
        return this.state.transaction.split.map((t, index) => {
            if (index === 1) {
                return (
                    <tr key={index + 1}>
                      <th scope="row">
                        <img src={t.frontend_info.image} alt="" className="img-fluid d-block m-auto" width="35"/>
                      </th>
                      <td>{t.frontend_info.description}</td>
                      <td className="p-0 m-0">

                          {/*
                           <select name="ngo" onChange={this.handleInputChange} value={this.state.ngo} className="form-control">
                           {this.state.ngos.map(ngo => (
                           <option key={ngo.key} selected={t.value_pair.uid === ngo.ngo_uid ? "selected" : ""} value={ngo.key}>
                           {ngo.name}
                           </option>
                           ))}
                           </select>
                           */}

                      </td>
                      <td>
                        <ShowValue btc={t.value_pair.value}/>
                      </td>
                    </tr>
                );
            } else {
                return (
                    <tr key={index + 1}>
                      <th scope="row">
                        <img src={t.frontend_info.image} alt="" className="img-fluid d-block m-auto" width="35"/>
                      </th>
                      <td>{t.frontend_info.description}</td>
                      <td>
                          {t.frontend_info.name ? t.frontend_info.name : this.props.current.previous_owners[0].name}
                      </td>
                      <td>
                        <ShowValue btc={t.value_pair.value}/>
                      </td>
                    </tr>
                );
            }
        });
    }
  }

  shareFB() {
    //let ngo_values;
    //let donation_value, ngo_name;
    //if (this.state.transaction.transaction[1]) {
    //  ngo_values = this.state.transaction.transaction[1];
    //  /*donation_value = ngo_values.value_pair.value;
    //  ngo_name = ngo_values.frontend_info.name.split("Default: ")[1];*/
    //}
    FB.ui(
      {
        method: "share",
        display: "popup",
        quote: `Hey facebook friends, I've just bought a Winvite at Winvite.io! Check this out.`,
        href: location.href
      },
      function (response) { }
    );
  }

  render() {
  	
  	const { t } = this.props;
  	
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className="modal-lg">
        <ModalBody>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <h1 className="mb-1">
	                {t('buy.buying')}{this.props.current.name}
                </h1>
              </div>
            </div>{" "}
            
            {/* Message Buying */}
            <div className="row justify-content-center">
              <div className="col-md-8">
                <p className="text-left" hidden={this.state.transaction.status !== "approved"}>
	                
	                <br />
	                <br />
	                <br />
	                {t('buy.congrats')}  <br /> {t('buy.youjustbought')} {" "} {this.props.current.name}{" "} {t('buy.withsuccess')}<br />
	                <br />
	                {t('buy.msg1')}
	                {/*Até o presente momento você é o feliz comprador deste Winvite e poderá desfrutar de uma experiência única!*/}
	                <br />
									<br />
	                {t('buy.msg2')}
	                {/*Acompanhe até o fechamento do leilão. O vencedor irá receber a confirmação por email.*/}
	                <br />
									<br />
	                {t('buy.msg3')}
	                {/*Se alguém cobrir sua oferta não se preocupe. Você receberá sua grana de volta e uma compensação de 20% sobre o lucro. */}
	                <br />
									<br />
	                {t('buy.msg4')}
	                {/*Ahh, lembramos que se você quiser muito curtir essa experiência basta voltar no sistema e dar outro lance.*/}
	                <br />
	                {t('buy.msg5')}
	                {/*O dinheiro já está disponível para você na sua conta : )*/}
	                <br />
									<br />
	                {t('buy.msg6')}
	                {/*Bons lances e Boa sorte!!!*/}
	                
                </p>
                <p className="text-center text-danger" hidden={this.state.transaction.status !== "not-allowed"}  >
	                {t('buy.notauthorized')}
                </p>

                <p className="text-center text-danger" hidden={this.state.transaction.status !== "toolate"}>
	                <br /><br />
	                {t('buy.blocked')}
	                {/*O seu winvite está bloqueado por 2 minutos. Aguarde e tente novamente...*/}
	                <br /><br />
                </p>
                <p className="text-center text-danger" hidden={this.state.transaction.status !== "refused"}>
	                {t('buy.refused')}
	                {/*Opps... Sua compra foi recusada... Desculpe-nos: */}{this.state.transaction.info }
                </p>
                <p className="text-center text-danger" hidden={!this.state.transaction.error} >
                  {this.state.transaction.message} <hr/>
                    {this.state.transaction.status}
                </p>
              </div>
            </div>{" "}
            {/* Messages */}
            
            <hr />
	          
            <div className="row justify-content-center"
                 hidden={this.state.transaction.status === "not-allowed" ||
                        this.state.transaction.status === "refused" ||
                        this.state.transaction.error ||
                        this.state.transaction.status === "approved"} >

              <div className="col-md-2">
                <img className="img-fluid" src={this.props.current.image} alt="main asset" />
              </div>{" "}
              {/* Image */}
	            
	            <div className="col-md-4">
                <p className="pt-1 text-left text-price">
	                {t('buy.buyingfor')}
	                {/*Você está comprando por : */}
                </p>
	            </div>
	            <div className="col-md-2 text-right">
		            <h3 className="text-right">
	                <ShowValue btc={this.props.current.previous_owners[0].previous_owner_asset_price} />
		            </h3>
	            </div>
            </div>{" "}
            
            <hr />
            <div className="row justify-content-center">
              <div className="col-md-8">
                <button className="btn btn-outline-success float-right"
                        hidden={this.state.transaction.error ||
                        (this.state.transaction.status !== "pending" && this.state.transaction.status !== "tfa") ||
                        !this.state.profile}
                        onClick={this.checkNextAction}
                        disabled={!this.props.current.previous_owners[0].previous_owner_asset_price || this.state.disableButton}>
	                {t('buy.confirm')}
                </button>{" "}
                {/* Confirm buy*/}
                  {/* onClick={this.responseGoogle} */}
                  {/*<button className="google-login float-right"  hidden={this.state.profile} >
                  <img className="google-img" width="20" alt="Logo Google" src="/assets/images/logo-google.png" />
                  <span className="google-text">You must Login to Buy</span>
                </button> */}{" "}
                {/* Login to buy */}
                <Button color="secondary" className="float-left" onClick={this.props.toggle} >
	                {t('common.back')}
                </Button>{" "}
                {/* Cancel or Ok? */}
                {/*<Link className="btn btn-outline-secondary"*/}
                        {/*to={ this.props.toggle }>*/}
                        {/*<i className="fas fa-caret-left"></i>*/}
                    {/*Back*/}
                {/*</Link> {" "}*/}
                {/* Back - Why this is not a button? */}
                {/*onClick={this.shareFB}*/}
	              <button className="btn btn-outline-primary float-right"
	                      hidden={this.state.transaction.status !== "approved"}>
                  <i className="fab fa-facebook-f" />
		              {t('common.share')}
                </button>{" "}
                {/* Share */}
              </div>
            </div>{" "}
            {/* Buying Buttons */}
            <hr />
            
	          <div className="row justify-content-center">
	            <div className="col-md-8">
	              
	              <p className="text-left" >
	                <br />
	                <br />
		              {t('common.remember')}
	                <br /><br />
		              {t('buy.tip1')}
	                {/*1 - Você deve colocar créditos para dar o seu lance. O leilão deve estar aberto (cronometro e botão VERDES)*/}
	                {/*Para colocar os créditos utilize o botão "Depositar" na sua Wallet (Login >> Wallet >> Depositar).*/}
		              <br />
	                <br /><br />
		              {t('buy.tip2')}
	                {/*2 - Cada lance será dividido entre o Artista (Banda/Influencer), Serviços (Agente), a Plataforma e os Participantes do leilão.*/}
									<br /><br />
		              {t('buy.tip3')}
	                {/*3 - Qualquer usuário pode dar outro lance em cima do seu.*/}
	                {/*Nesse caso, você receberá o que pagou mais 20% (vinte por cento) da diferença.*/}
	                {/*Os valores estarão disponíveis para uso na plataforma imediatamente.*/}
	                {/*Ao final do leilão, caso você nao seja o vencedor, você podera solicitar o estorno integral da compra e o cancelamento dos créditos (vide regras simples).*/}
	                <br /><br />
		              {t('buy.tip4')}
	                {/*4 - O lance vencedor no final do leilão (cronômetro vermelho) será o proprietário do Winvite e terá direito à usufruir da experiência única conforme os termos e condições da oferta.*/}
	                <br /><br />
	                <br />
		              {t('buy.tip5')}
	                {/*Ao confirmar você poderá ver suas aquisições e os lances de que participou no menu Login >> Profile.*/}
	              </p>
	             
	            </div>{" "}
            </div>
            {/* Table Price - Fee - Total */}
            
          </div>{" "}
          {/* Modal Body */}
        </ModalBody>
        <Loading active={this.state.loading} />
      </Modal >
    );
  }
}

export default withTranslation()(BuyModal);



// WEBPACK FOOTER //
// ./src/containers/AssetPage/buy-modal.js